import React from 'react';
import { StyleSheet, View, Text } from 'react-native';
import FastImageView from '../../components/FastImageView';
import RemoteConfig from '../../utils/RemoteConfig';
import { jsonParser } from '../../utils/JsonUtility';
import { REMOTE_CONFIG_KEYS } from '../../config/Constants';
import colors from '../../theme/Colors';
import LinearGradient from 'react-native-linear-gradient';

const gradientColors = ['#FFF6F6', '#FFFFFF'];
const gradientStart = { x: 0, y: 1 };
const gradientEnd = { x: 1, y: 0 };

const ProductPriceGuarantee = () => {
  const productPriceGuaranteeData = jsonParser(RemoteConfig.getValue(REMOTE_CONFIG_KEYS.product_price_guarantee));
  const { title = '', subtitle = '', image_url = '', show_price_guarantee = false } = productPriceGuaranteeData;
    if (!show_price_guarantee) return null;
  return (
    <View style={styles.container}>
      <LinearGradient
        colors={gradientColors}
        start={gradientStart}
        end={gradientEnd}
        style={styles.contentContainer}
      >
        <View style={styles.titleContainer}>
          <FastImageView source={image_url} style={styles.image} />
          <View>
            <Text numberOfLines={1} ellipseMode='tail' style={styles.title}>
              {title}
            </Text>
            <Text numberOfLines={2} ellipseMode='tail' style={styles.subtitle}>
              {subtitle}
            </Text>
          </View>
        </View>
      </LinearGradient>
    </View>
  );
};

export default ProductPriceGuarantee;

const styles = StyleSheet.create({
  container: {
    padding: 12,
    paddingTop: 24,
    backgroundColor: colors.white,
  },
  contentContainer: {
    borderRadius: 16,
    borderWidth: 1,
    borderColor: colors.border,
    backgroundColor: '#FFF6F6',
    paddingVertical: 12,
  },
  image: {
    height: 40,
    width: 40,
    resizeMode: 'contain',
    marginLeft: 12,
  },
  titleContainer: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  title: {
    fontSize: 14,
    color: colors.foxyBlack,
    fontFamily: 'Roboto-Medium',
    flex: 1,
    marginRight: 12,
    marginLeft: 6,
  },
  subtitle: {
    fontSize: 12,
    color: colors.subtitle,
    fontFamily: 'Roboto-Regular',
    marginHorizontal: 6,
  },
  subtitleContainer: {
    borderRadius: 16,
    borderWidth: 1,
    borderColor: colors.border,
    backgroundColor: colors.white,
  },
});
